
import React, { PropTypes } from 'react';

export class Ellipsis extends React.Component {

  static propTypes = {
    colorSchema: PropTypes.string,
    fill: PropTypes.bool
  };

  getFillColor () {
    switch (this.props.colorSchema) {
      case 'primary':
        return '#00587c';
      default:
        return '#000000';
    }
  }

  render () {
    const fill = this.props.fill
      ? ''
      : ' 9c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5c0-0.827-0.673-1.5-1.5-1.5z';

    return (
      <svg width='20' height='20' viewBox='0 0 20 20'>
        <path d={
          'M2.5 13c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z' +
          (fill ? 'M2.5' + fill : '')}
          fill={this.getFillColor()}></path>
        <path d={
          'M9.5 13c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z' +
          (fill ? 'M9.5' + fill : '')}
          fill={this.getFillColor()}></path>
        <path d={
          'M16.5 13c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z' +
          (fill ? 'M16.5' + fill : '')}
          fill={this.getFillColor()}></path>
      </svg>
    );
  }
}

export default Ellipsis;



/** WEBPACK FOOTER **
 ** ./src/components/svg/ellipsis.js
 **/